import { useMemo } from 'react';
import { SummaryDealExtendedTct } from '@dealstack/shared/lib/generated';
import { useDocumentBreadcrumbs } from '@dealstack/frontend/app/pages/Project/MIP/MIPManage/Documents/hooks/useDocumentBreadcrumbs';
import { PageHeader } from '@dealstack/frontend/shared/layout/PageHeader/PageHeader';

interface Props {
	deal?: SummaryDealExtendedTct;
	mipId?: string;
	documentName?: string;
}

export const DocumentPreviewHeader = ({ deal, mipId, documentName }: Props) => {
	const currentMip = useMemo(() => deal?.mips.find((mip) => mip.id === mipId), [deal, mipId]);

	useDocumentBreadcrumbs({ view: 'home', dealId: deal?.id, currentMip });

	if (!documentName) {
		return null;
	}

	return <PageHeader pageTitle={documentName} hideBreadcrumbs />;
};
